import { PaymentProcessorConfigurationBase } from '../payment-processor-configuration-base';

export class PayGovPaymentProcessorConfiguration extends PaymentProcessorConfigurationBase {
  multiPaymentURL: string;

  constructor(options?: Partial<PayGovPaymentProcessorConfiguration>) {
    super(options);

    if (options) {
      Object.assign(this, options);
    }
  }
}
